declare global {
  interface Window {
    scrollTop: number
    shouldPreserveScroll: boolean
    Turbo: {
      navigator: {
        currentVisit: {
          scrolled: boolean
        }
      }
    }
  }
}

window.scrollTop = 0
window.shouldPreserveScroll = false

const insidePreserveScroll = (element: HTMLElement) => {
  while (element) {
    if (element.hasAttribute('data-turbo-preserve-scroll')) {
      return true
    }
    element = element.parentElement
  }
  return false
}

document.addEventListener("turbo:click", (event)=> {
  window.shouldPreserveScroll = insidePreserveScroll(event.target as HTMLElement)
})

document.addEventListener("turbo:submit-start", (event) => {
  window.shouldPreserveScroll = insidePreserveScroll((event as CustomEvent).detail.formSubmission.submitter)
})

document.addEventListener("turbo:visit", () => {
  window.scrollTop = window.shouldPreserveScroll ? document.documentElement.scrollTop : 0
  window.Turbo.navigator.currentVisit.scrolled = true
  window.scrollTo({ top: window.scrollTop, behavior: "smooth" })
})

export {}
